import React from "react";
import { Box, Grid2, Typography } from "@mui/material";

interface Props {
  component1?: React.ReactNode;
  component2?: React.ReactNode;
  title?: string;
  marginBottom?: number;
}

export const TwoColLayout = ({
  component1,
  component2,
  title,
  marginBottom,
}: Props) => {
  return (
    <Box>
      {title && (
        <Typography
          variant="subtitle1"
          fontWeight={600}
          mb={marginBottom || 3.5}
        >
          {title}
        </Typography>
      )}
      <Grid2 container spacing={5}>
        {component1 && <Grid2 size={{ xs: 12, md: 6 }}>{component1}</Grid2>}
        {component2 && <Grid2 size={{ xs: 12, md: 6 }}>{component2}</Grid2>}
      </Grid2>
    </Box>
  );
};
